export type {
  ReportComponent,
  ComponentType,
  ComponentDefinition,
  ComponentField,
} from '@/types/reports';

import type { ReportWithContent } from '@/types/reports';

export type Report = ReportWithContent;

import type { ComponentDefinition } from '@/types/reports';
import { TIKTOK_TRENDS_DEFINITION } from '@/pages/reports/components/ui/TiktokTrends';

export const COMPONENT_DEFINITIONS: ComponentDefinition[] = [
  {
    type: 'hero',
    name: 'Capa',
    description: 'Seção principal com imagem e texto',
    fields: [
      { key: 'date', label: 'Data', type: 'date', required: true },
      { key: 'edition', label: 'Edição', type: 'text', required: true },
      { key: 'topCenterImage', label: 'Logo da marca (Amstel, Electrolux...)', type: 'url' },
      { key: 'topRightImage', label: 'Imagem Superior Direita', type: 'url', required: true },
      { key: 'bottomLeftImage', label: 'Imagem Inferior Esquerda', type: 'url', required: true },
      { key: 'backgroundColor', label: 'Cor de Fundo', type: 'text' },
      { key: 'textColor', label: 'Cor do Texto', type: 'text' },
      { key: 'logoLinks', label: 'Logos (abaixo da data/edição)', type: 'logo-links' }
    ]
  },
  {
    type: 'today-carousel',
    name: 'Trending Topics',
    description: 'Carrossel com slides contendo título destacado e blocos de texto',
    fields: [
      { 
        key: 'slides', 
        label: 'Slides', 
        type: 'slides', 
        required: true 
      }
    ]
  },
  {
    type: 'highlights-card',
    name: 'Pontos de Atenção',
    description: 'Bloco com título, subtítulo e lista de itens em destaque',
    fields: [
      {
        key: 'subtitle',
        label: 'Descrição',
        type: 'rich-text'
      },
      {
        key: 'illustration',
        label: 'Ilustração (URL da imagem)',
        type: 'image'
      },
      {
        key: 'items',
        label: 'Itens em destaque',
        type: 'highlights',
        required: true
      }
    ]
  },
  {
    type: 'news-card',
    name: 'Assuntos/Formatos',
    description: 'Card para destacar notícia com redes sociais e lista de destaques',
    fields: [
      {
        key: 'badgeLabel',
        label: 'Etiqueta',
        type: 'select',
        required: true,
        options: [
          { value: 'Formato', label: 'Formato' },
          { value: 'Assunto', label: 'Assunto' },
          { value: 'Trends', label: 'Trends' },
          { value: 'Influenciador', label: 'Influenciador' },
          { value: 'Outro', label: 'Outro' },
        ],
      },
      {
        key: 'badgeLabelCustom',
        label: 'Etiqueta personalizada (quando "Outro" for selecionado)',
        type: 'text',
      },
      {
        key: 'socialList',
        label: 'Redes sociais',
        type: 'social',
        required: true
      },
      {
        key: 'coverImage1',
        label: 'Imagem 1 (URL)',
        type: 'url',
        group: 'Imagens de capa',
      },
      {
        key: 'coverImage2',
        label: 'Imagem 2 (URL)',
        type: 'url',
        group: 'Imagens de capa',
      },
      {
        key: 'coverImage3',
        label: 'Imagem 3 (URL)',
        type: 'url',
        group: 'Imagens de capa',
      },
      {
        key: 'coverImage4',
        label: 'Imagem 4 (URL)',
        type: 'url',
        group: 'Imagens de capa',
      },
      {
        key: 'title',
        label: 'Título',
        type: 'text',
        required: true
      },
      {
        key: 'titleLink',
        label: 'Link do título (URL)',
        type: 'url-text'
      },
      {
        key: 'subsections',
        label: 'Caixas de texto',
        type: 'news-subsections',
      },
    ]
  },
  {
    type: 'business-card',
    name: 'Business',
    description: 'Card com imagem, título e texto complementar opcional',
    fields: [
      {
        key: 'sectionTitle',
        label: 'Título da seção (opcional)',
        type: 'text',
      },
      {
        key: 'img',
        label: 'Imagem (URL)',
        type: 'url'
      },
      {
        key: 'title',
        label: 'Título da notícia',
        type: 'text',
        required: true
      },
      {
        key: 'titleLink',
        label: 'Link do título (URL)',
        type: 'url-text'
      },
      {
        key: 'complementaryText',
        label: 'Texto complementar opcional',
        type: 'rich-text'
      }
    ]
  },
  {
    type: 'thematic-session',
    name: 'Seção Temática',
    description: 'Bloco especial reutilizável para eventos e períodos sazonais',
    fields: [
      {
        key: 'logoImage',
        label: 'Logo / imagem do evento (topo)',
        type: 'url',
      },
      {
        key: 'backgroundColor',
        label: 'Cor de fundo',
        type: 'text',
      },
      {
        key: 'backgroundImage',
        label: 'Imagem de fundo (URL)',
        type: 'url',
      },
      {
        key: 'coverImage',
        label: 'Imagem 1 (URL)',
        type: 'url',
        group: 'Imagens de capa',
      },
      {
        key: 'coverImage2',
        label: 'Imagem 2 (URL)',
        type: 'url',
        group: 'Imagens de capa',
      },
      {
        key: 'coverImage3',
        label: 'Imagem 3 (URL)',
        type: 'url',
        group: 'Imagens de capa',
      },
      {
        key: 'coverImage4',
        label: 'Imagem 4 (URL)',
        type: 'url',
        group: 'Imagens de capa',
      },
      {
        key: 'title',
        label: 'Título da seção',
        type: 'text',
        required: true,
      },
      {
        key: 'titleLink',
        label: 'Link do título (URL)',
        type: 'url-text',
      },
      {
        key: 'description',
        label: 'Descrição',
        type: 'rich-text',
      },
      {
        key: 'validFrom',
        label: 'Válido de (opcional)',
        type: 'text',
      },
      {
        key: 'validTo',
        label: 'Válido até (opcional)',
        type: 'text',
      },
      {
        key: 'subsections',
        label: 'Seções de conteúdo',
        type: 'thematic-subsections',
      },
    ],
  },
  {
    type: 'curatorship',
    name: 'Curadoria',
    description: 'Links e referências complementares ao monitoramento',
    fields: [
      {
        key: 'sectionTitle',
        label: 'Título da seção',
        type: 'text',
        required: true,
      },
      {
        key: 'intro',
        label: 'Texto introdutório (opcional)',
        type: 'rich-text',
      },
      {
        key: 'presentation',
        label: 'Como exibir os links',
        type: 'select',
        options: [
          { value: 'list', label: 'Lista com marcadores' },
          { value: 'blocks', label: 'Blocos em texto corrido' },
        ],
      },
      {
        key: 'items',
        label: 'Itens de curadoria',
        type: 'curatorship-items',
      },
    ],
  },
  TIKTOK_TRENDS_DEFINITION,
  {
    type: 'collapsible-hashtags',
    name: 'Hashtags',
    description: 'Seção colapsável com hashtags por categoria (legado)',
    fields: [
      { key: 'title', label: 'Título', type: 'text' },
      { key: 'subtitle', label: 'Subtítulo', type: 'text' },
      { key: 'categories', label: 'Categorias e hashtags', type: 'hashtag-categories' }
    ]
  },
  {
    type: 'collapsible-creators',
    name: 'Creators',
    description: 'Seção colapsável com creators/influenciadores (legado)',
    fields: [
      { key: 'title', label: 'Título', type: 'text' },
      { key: 'subtitle', label: 'Subtítulo', type: 'text' },
      { key: 'creators', label: 'Creators', type: 'creator-entries' }
    ]
  },
  {
    type: 'collapsible-brands',
    name: 'Marcas',
    description: 'Seção colapsável com marcas (legado)',
    fields: [
      { key: 'title', label: 'Título', type: 'text' },
      { key: 'subtitle', label: 'Subtítulo', type: 'text' },
      { key: 'brands', label: 'Marcas', type: 'brand-entries' }
    ]
  }
];
